import { useEffect, useState } from 'react';
import { Box } from '@mantine/core';
import { useParams } from 'react-router';
import LineChart from '../../components/Charts/LineChart';
import ErrorMessage from '../../components/ErrorMessage';
import Spinner from '../../components/Spinner';
import useFetch from '../../helpers/useFetch';

const ProfilesDetailsMessageStatsPage = ({ trackingId }) => {
  const fetch = useFetch();
  const [histogram, setHistogram] = useState();
  const [error, setError] = useState();
  const { accountId, domainId } = useParams();

  useEffect(() => {
    setHistogram(undefined);
    fetch(
      `/api/admin/accounts/${accountId}/domains/${domainId}/profiles/histogram?id=${encodeURIComponent(trackingId)}`,
      {}
    )
      .then(({ histogram }) => {
        setHistogram(histogram);
      })
      .catch(setError);
  }, [accountId, domainId, fetch, trackingId]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  if (histogram === undefined) {
    return <Spinner />;
  }

  return (
    <>
      {histogram.length > 0 ? (
        <LineChart data={histogram} title="Message Interactions" />
      ) : (
        <Box ta="center">No data was found.</Box>
      )}
    </>
  );
};

export default ProfilesDetailsMessageStatsPage;
